module.exports = __webpack_public_path__ + "assets/img/head-bj.febd6fc6.png";